import {
	Model,
	PurchaseOrder,
	TransactionErrorType
} from ".";

export default class PurchaseOrderError extends Model {
	get singularNoun() {
		return "purchase order error";
	}

	get mutations() {
		return {
			purchaseOrder: PurchaseOrder,
			errorTypes: TransactionErrorType
		};
	}

	get purchaseOrderNumbers() {
		if ( this.purchaseOrders ) {
			return this.purchaseOrders.map( po => po.purchaseOrderNumber ).join( ", " );
		}
	}

	get errorTypeNames() {
		if ( this.errorTypes ) {
			return this.errorTypes.map( type => type.name ).join( ", " );
		}
	}

	resource() {
		return "sales/purchase-orders/errors";
	}
}
